import { Box, IconButton, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import { Copy } from '@astronautsid/wpe-icons'
import SupplyOrderStatusChip from 'features/SupplyOrder/components/SupplyOrderStatusChip/SupplyOrderStatusChip'
import { shallowEqual, useAppSelector } from 'store'
import { dateFormat } from 'utils/helpers/date'
import { toastNeutral } from 'utils/toast'

type InfoRowPropsType = {
  label: string
  value: React.ReactNode
  labelColor?: string
}

const InfoRow = ({ label, value, labelColor = '#646464' }: InfoRowPropsType) => (
  <Box display="flex" alignItems="center">
    <Box minWidth={210}>
      <Typography variant="body-small" color={labelColor}>
        {label}
      </Typography>
    </Box>
    {typeof value === 'string' || typeof value === 'number' ? (
      <Typography variant="headline-small">{value}</Typography>
    ) : (
      value
    )}
  </Box>
)

const BasicDetail = () => {
  const data = useAppSelector((state) => state.outboundSODetail.data, shallowEqual)

  return (
    <Box
      id="detail-dasar"
      borderRadius="8px"
      border="1px solid"
      borderColor={theme.colors.border}
      backgroundColor={theme.colors.white}
      padding="24px"
      overflow="auto"
    >
      <Typography variant="display-tiny" marginBottom="16px">
        Detail Dasar
      </Typography>

      <Box display="flex" flexDirection="column" gap="16px" mt="32px">
        <InfoRow
          label="Status"
          value={
            data?.supplyOrderStatus ? (
              <SupplyOrderStatusChip status={data.supplyOrderStatus} />
            ) : (
              '-'
            )
          }
        />

        <InfoRow
          label=" Nomor Supply Order"
          value={
            data?.supplyOrderNumber ? (
              <Box display="flex" gap="8px" alignItems="center">
                <Typography variant="headline-small">{data.supplyOrderNumber}</Typography>
                <IconButton
                  onClick={() => {
                    toastNeutral(`Nomor Supply Order berhasil di salin`)
                    navigator.clipboard.writeText(data?.supplyOrderNumber || '')
                  }}
                >
                  <Copy type="solid" color="#246EE5" />
                </IconButton>
              </Box>
            ) : (
              '-'
            )
          }
        />

        <InfoRow label="Type SO" value={data?.supplyOrderType} />
        <InfoRow label="SO Reff" value={data?.supplyOrderReff || '-'} />
        <InfoRow label="Asal" value={data?.locationOriginName} />
        <InfoRow label="Tujuan" value={data?.locationDestinationName} />
        <InfoRow label="Email" value={data?.supplyOrderRequestBy} />
        <InfoRow label="Dibuat oleh" value={data?.supplyOrderCreatedBy} />
        <InfoRow
          label="Tanggal SO"
          value={
            data?.supplyOrderDate
              ? dateFormat({
                  date: data.supplyOrderDate,
                  format: 'DD MMMM YYYY',
                })
              : '-'
          }
        />
        <InfoRow
          label="Tanggal Dibuat"
          value={
            data?.supplyOrderCreatedAt
              ? dateFormat({
                  date: data.supplyOrderCreatedAt,
                  format: 'DD MMMM YYYY HH:mm',
                })
              : '-'
          }
        />
        <InfoRow label="Remarks" value={data?.supplyOrderRemarks} />
        <InfoRow
          label="Instruksi Pengiriman"
          value={
            <Typography variant="body-small">
              {data?.supplyOrderShippingInstructions || '-'}
            </Typography>
          }
        />
      </Box>
    </Box>
  )
}

export default BasicDetail
